import { Radio, RadioGroup } from '@mui/material';
import styled from 'styled-components';

export const Margin = styled.div`
  height: 30px;

  @media screen and (max-width: 767px) {
    height: 20px;
  }
`;

export const SubmitBtn = styled.div`
  border-radius: 99px;
  background: var(--Primary-Info-Red-Original, #D40020);
  box-shadow: 0 4px 10px 0 rgba(0, 0, 0, 0.15);
  padding: 16px 10px;
  width: auto;
  cursor: pointer;
  color: #fff;
  font-family: Poppins-Bold;
  font-style: normal;
  font-weight: bold;
  font-size: 16px;
  line-height: 24px;
  text-align: center;
  margin-bottom: 5px;
  margin-top: 24px;
  min-width: 200px;
  width: 100%;

  display: flex;
  justify-content: center;
  align-items: center;

  &[disabled] {
    pointer-events: none;
    opacity: 0.8;
  }
`;

export const CancelBtn = styled.div`
  background: transparent;
  box-shadow: 0px 10px 20px rgba(0, 0, 0, 0.15);
  border-radius: 500px;
  padding: 10px 45px;
  width: auto;
  cursor: pointer;
  color: #D40020;
  font-family: Poppins-Bold;
  font-style: normal;
  font-weight: bold;
  font-size: 16px;
  line-height: 24px;
  text-align: center;
  margin: 0;
  border: 1px solid #D40020;
  min-width: 200px;
  width: 100%;

  display: flex;
  justify-content: center;
  align-items: center;

  &[disabled] {
    pointer-events: none;
    opacity: 0.8;
  }
`;

export const ActionRow = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: 40px;
  justify-content: flex-end;
`;

export const LabelDescription = styled.span`
  font-family: Poppins-Regular;
  font-style: normal;
  font-size: 11px;
  line-height: 21px;
  color: #979797;
  margin-left: 5px;
`;

export const RadioPrimary = styled(Radio)`
  padding-top: 0 !important;
  padding-bottom: 0 !important;
  margin-top: 0 !important;
  margin-bottom: 0 !important;

  &.Mui-checked {
    color: #202022 !important;
  }
`;

export const RadioGroupPrimary = styled(RadioGroup)`
  padding-top: 0 !important;
  padding-bottom: 0 !important;
  margin-top: 0 !important;
  margin-bottom: 0 !important;
`;
